import createClient from 'openapi-fetch';
import { getAccessToken } from '@/lib/auth';
import { getPlatformApiUrl } from '@/lib/platform-api-url';
import { isGlobalSurface } from '@/lib/surface-mode';
import type { paths } from '@/types/platform-api';

// Global: placeholder so module init does not throw before a cell is bound.
// onRequest rewrites to the live cell origin (including after a market switch).
export const platformApi = createClient<paths>({
  baseUrl: isGlobalSurface() ? 'https://cell.invalid' : getPlatformApiUrl(),
});

platformApi.use({
  async onRequest({ request }) {
    const url = new URL(request.url);
    const req = isGlobalSurface() ? new Request(`${getPlatformApiUrl().replace(/\/$/, '')}${url.pathname}${url.search}`, request) : request;
    const token = await getAccessToken();
    if (token) req.headers.set('Authorization', `Bearer ${token}`);
    req.headers.set('X-Request-ID', crypto.randomUUID());
    return req;
  },
});
